import { UpdateEventVariantDocument } from '@/generated/graphql';
import { useMutation } from '@vue/apollo-composable';

export function useEventVariantUpdate() {
    const updateVariantMutation = useMutation(UpdateEventVariantDocument, {
        fetchPolicy: 'no-cache',
    });

    async function updateEventVariantName(id: string, name: string, feedId: string) {
        const result = await updateVariantMutation.mutate({ id, name, feedId });
        return result;
    }

    return {
        updateEventVariantName,
    };
}
